export const significanceColors = {
  success: '#33a66c',
  danger: '#ff0000',
};
